// Messages for operator/settings/Diagnostics (auto-merged into the i18n catalog).
export const en = {
  'operator.diagnostics.head': 'Diagnostics — Operator',
  'operator.diagnostics.title': 'Diagnostics',
  'operator.diagnostics.desc': 'A read-only snapshot of the running app, datastores and job queue.',
  'operator.diagnostics.app': 'Application',
  'operator.diagnostics.env': 'Environment',
  'operator.diagnostics.ruby': 'Ruby',
  'operator.diagnostics.rails': 'Rails',
  'operator.diagnostics.revision': 'Revision',
  'operator.diagnostics.time': 'Server time',
  'operator.diagnostics.zone': 'Time zone',
  'operator.diagnostics.datastores': 'Datastores',
  'operator.diagnostics.store.database': 'Database',
  'operator.diagnostics.store.cache': 'Cache',
  'operator.diagnostics.queue': 'Job queue',
  'operator.diagnostics.queue_pending': 'Pending',
  'operator.diagnostics.queue_scheduled': 'Scheduled',
  'operator.diagnostics.queue_failed': 'Failed',
  'operator.diagnostics.flags': 'Feature flags',
  'operator.diagnostics.no_flags': 'No optional modules registered.',
  'operator.diagnostics.on': 'On',
  'operator.diagnostics.off': 'Off',
}

export const zhTW = {
  'operator.diagnostics.head': '診斷 — 操作員',
  'operator.diagnostics.title': '診斷',
  'operator.diagnostics.desc': '正在執行的應用程式、資料儲存與工作佇列的唯讀快照。',
  'operator.diagnostics.app': '應用程式',
  'operator.diagnostics.env': '環境',
  'operator.diagnostics.ruby': 'Ruby',
  'operator.diagnostics.rails': 'Rails',
  'operator.diagnostics.revision': '版本',
  'operator.diagnostics.time': '伺服器時間',
  'operator.diagnostics.zone': '時區',
  'operator.diagnostics.datastores': '資料儲存',
  'operator.diagnostics.store.database': '資料庫',
  'operator.diagnostics.store.cache': '快取',
  'operator.diagnostics.queue': '工作佇列',
  'operator.diagnostics.queue_pending': '待處理',
  'operator.diagnostics.queue_scheduled': '已排程',
  'operator.diagnostics.queue_failed': '失敗',
  'operator.diagnostics.flags': '功能旗標',
  'operator.diagnostics.no_flags': '未註冊任何選用模組。',
  'operator.diagnostics.on': '開啟',
  'operator.diagnostics.off': '關閉',
}
